import type { INavTabProps } from './NavTab'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import { NavDirection } from './NavTab.h'

export const NavTabLink = styled.div<
  Omit<INavTabProps, 'title' | 'color'> & {
    colorDefault: INavTabProps['color']
  }
>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContentTab }) => `${justifyContentTab}`};
  align-items: center;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  max-width: ${({ width, direction }) =>
    direction === NavDirection.ROW ? `${width}px` : 'inherit'};
  background-color: ${({ background }) => `var(${background})`};
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding: FIXED_INDENTS) => `var(${padding})`).join(' ')
      : 0};
  min-width: ${({ width, direction, icon, title }) =>
    icon && title
      ? `${width}px`
      : direction === NavDirection.COLUMN
        ? `inherit`
        : 'max-content'};

  ${TextBoxSC} {
    color: ${({ colorDefault }) =>
      colorDefault ? `var(${colorDefault})` : 'inherit'};
    display: block;
    font: ${({ font }) => `var(${font})`};
  }

  ${IconSC} {
    color: ${({ colorDefault, selected, colorSelected }) =>
      selected ? `var(${colorSelected})` : `var(${colorDefault})`};
    margin: ${({ iconPosition }) =>
      iconPosition === 'left'
        ? `0 var(${FIXED_INDENTS.INDENT_40}) 0 0`
        : `0 0 0 var(${FIXED_INDENTS.INDENT_40})`};
    order: ${({ iconPosition }) => (iconPosition === 'left' ? 0 : 1)};

    &:only-child {
      margin: 0;
    }
  }

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background-color: ${({ background, backgroundHovered }) =>
        backgroundHovered ? `var(${backgroundHovered})` : `var(${background})`};

      & ${TextBoxSC} {
        color: ${({ colorHovered }) =>
          colorHovered ? `var(${colorHovered})` : 'inherit'};
      }

      & ${IconSC} {
        color: ${({ colorHovered }) =>
          colorHovered ? `var(${colorHovered})` : 'inherit'};
      }
    }

    &:active {
      background-color: ${({ background, backgroundPressed }) =>
        backgroundPressed ? `var(${backgroundPressed})` : `var(${background})`};

      & ${TextBoxSC} {
        color: ${({ colorPressed, colorDefault }) =>
          colorPressed ? `var(${colorPressed})` : `var(${colorDefault})`};
      }

      & ${IconSC} {
        color: ${({ colorPressed }) =>
          colorPressed ? `var(${colorPressed})` : 'inherit'};
      }
    }
  }
`

export const NavTabSC = styled.li<
  Omit<INavTabProps, 'title' | 'color' | 'index'> & {
    colorDefault?: INavTabProps['color']
  }
>`
  list-style: none;
  color: inherit;

  .active${NavTabLink} {
    background-color: ${({ background, icon, selected, backgroundSelected }) =>
      icon && selected ? `var(${backgroundSelected})` : `var(${background})`};

    ${TextBoxSC} {
      color: ${({ selected, colorSelected }) =>
        selected ? `var(${colorSelected})` : 'inherit'};
    }

    ${IconSC} {
      color: ${({ selected, colorSelected }) =>
        selected ? `var(${colorSelected})` : 'inherit'};
    }
  }
`
